import moment from 'moment';

export const setDateRangeEndToNow = (dateRange) => {
  if (dateRange.type !== "relative") {
    dateRange = {
      ...dateRange,
      end: moment().toISOString(),
    };
  }
  return dateRange;
};
